import { getBatterySoH } from '../../../../helpers/getBatterySoH';

import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TabPanelBatteryElectricals: FunctionComponent<Props> = ({
    battery,
    className = '',
    cycleInterval,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const { electricals } = battery;
    const notReported = t.NOT_APPLICABLE_NOT_REPORTED;
    const soH = getBatterySoH({ battery, cycleInterval });
    const soHValue = soH.available ? `${Math.round(soH.percent)}%` : notReported;
    const metrics = [
        {
            label: t.BATTERY_VOLTAGE,
            value: electricals.reported ? `${electricals.voltage} V` : notReported
        },
        {
            label: t.BATTERY_CURRENT,
            value: electricals.reported ? `${electricals.currentAmps} A` : notReported
        },
        {
            label: t.BATTERY_TEMPERATURE,
            value: electricals.reported ? `${electricals.temperatureCelsius} °C` : notReported
        },
        {
            label: t.CELL_VOLTAGES,
            value: electricals.reported ? electricals.cellVoltages.join(', ') : notReported
        },
        { label: t.STATE_OF_HEALTH, value: soHValue }
    ];

    return (
        <VerticalContainer className={`${styles.electricalsTable} ${className}`} testId={testId}>
            {metrics.map(metric => (
                <HorizontalContainer className={styles.metricRow} key={metric.label}>
                    <Wrapper className={styles.metricLabel}>{metric.label}</Wrapper>

                    <Wrapper className={styles.metricValue}>{metric.value}</Wrapper>
                </HorizontalContainer>
            ))}
        </VerticalContainer>
    );
};

export default TabPanelBatteryElectricals;
